module.exports = __webpack_public_path__ + "files/2668c8278a2e5c32096f4def1b835e94.png";